import joi from '@hapi/joi';

// Phone validation:
// allowed chars, no consecutive hyphens, 7–16 digits, and after country code only digits/spaces.
const PHONE_ALLOWED_CHARS = /^\+?[()\d\s-]+$/;
const PHONE_NO_CONSECUTIVE_HYPHENS = /^(?!.*--).*$/;

const joiWithPhone = joi.extend({
  base: joi.string(),
  name: 'phone',
  rules: [
    {
      name: 'format',
      validate(_arg: unknown, value: string, state: unknown, options: unknown) {
        const digits = value.replace(/[^\d]/g, '');
        if (digits.length < 7 || digits.length > 16) {
          return (this as any).createError(
            'phone.digits',
            { value },
            state,
            options,
          );
        }
        const afterCode = value.replace(/^\+?\d*/, '');
        if (!/^[\d\s]*$/.test(afterCode)) {
          return (this as any).createError(
            'phone.afterCode',
            { value },
            state,
            options,
          );
        }
        return value;
      },
    },
  ],
} as any);

export const profileUpdateDetailsSchema = joi
  .object({
    email: joi
      .string()
      .trim()
      .regex(
        /^(?:$|([^@;\s]+@[^@;\s]+\.[^@;\s]+)(\s*;\s*[^@;\s]+@[^@;\s]+\.[^@;\s]+)*\s*;*\s*)$/,
      )
      .required()
      .error((err: any) => {
        const type = err?.[0]?.type;
        if (
          type === 'string.empty' ||
          type === 'any.empty' ||
          type === 'any.required'
        ) {
          return 'Please provide your email address.';
        }
        return "Please provide a valid email address. Multiple emails should be separated by ';'.";
      }),
    phone: joiWithPhone
      .phone()
      .trim()
      .required()
      .regex(PHONE_ALLOWED_CHARS, { name: 'allowedChars' })
      .regex(PHONE_NO_CONSECUTIVE_HYPHENS, { name: 'noConsecutiveHyphens' })
      .format()
      .error((err: any) => {
        const type = err?.[0]?.type;
        const contextName = err?.[0]?.context?.name;
        if (
          type === 'string.empty' ||
          type === 'any.empty' ||
          type === 'any.required'
        ) {
          return 'Please provide your phone number.';
        }
        if (type === 'phone.digits') {
          return 'Phone number must contain between 7 and 16 digits.';
        }
        if (type === 'phone.afterCode') {
          return 'After the country code, only digits and spaces are allowed.';
        }
        if (type === 'string.regex.base') {
          if (contextName === 'noConsecutiveHyphens') {
            return 'Consecutive hyphens are not allowed.';
          }
          return 'Invalid phone number format.';
        }
        return 'Please provide your phone number.';
      }),
  })
  .required();
